export default "__VITE_ASSET__C1SBBjsG__ 600w";